import { SET_PAYER_NAMES } from "../actions/action.types";

export const setPayerNames = (state = [], action: any) => {
  if (action.type === SET_PAYER_NAMES) {
    return action.payload;
  } else {
    return state;
  }
};
